import React, {useState, useEffect, useRef} from "react";
import { Row,Col } from 'react-bootstrap';
import styled from "styled-components";
import Header from "./Header";
import Toolbar from "./Toolbar";
import Loader from "../../../globals/Loader";

import ls from 'local-storage';

const ColStyle = styled(Col)`
  margin:0;
  padding:0;
  display:flex;
  justify-content:${props => props.align};
  align-items:center;
`;
const Wrapper = styled.div`
  width:100%;
  overflow-y:hidden;
`;

const GridContainer = styled(Row)`
  height: calc(100% - 162px);
  margin: 0;
  padding: 0;
  position:relative;
`;
function ProfileUsers (){
  
  const [ready, setReady] = useState(false);

  useEffect(()=>{
    setTimeout(()=>{
      setReady(true);
    },500);
  },[]);
  if(ready){
    return (
      <Wrapper id={"reporte_conceptos_container"}>
        <Header/>
        <Toolbar/>
      </Wrapper>
    );
  }
  else{
    return (
      <Loader/>
    );
  }
 
}
export default ProfileUsers;